import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleControlSidebar, toggleSidebarMenu } from '@app/store/reducers/ui';
// import MessagesDropdown from '@app/modules/main/header/messages-dropdown/MessagesDropdown';
// import NotificationsDropdown from '@app/modules/main/header/notifications-dropdown/NotificationsDropdown'; 
import UserDropdown from '@app/modules/main/header/user-dropdown/UserDropdown';

const Header = (props: any) => {
  const dispatch = useDispatch();
  const navbarVariant = useSelector((state: any) => state.ui.navbarVariant);
  const headerBorder = useSelector((state: any) => state.ui.headerBorder);

  const handleToggleMenuSidebar = () => {
    dispatch(toggleSidebarMenu());
  };

  const handleToggleControlSidebar = () => {
    dispatch(toggleControlSidebar());
  };

  const getContainerClasses = useCallback(() => {
    let classes = `main-header navbar navbar-expand ${navbarVariant}`;
    if (headerBorder) {
      classes = `${classes} border-bottom-0`;
    }
    if (props.user && props.role_id != 1) {
      classes = `${classes} adminheader`;
    }
    return classes;
  }, [navbarVariant, headerBorder]);

  return (
    <nav className={getContainerClasses()}>
      {props.user && props.role_id == 1 &&
        <ul className="navbar-nav">
          <li className="nav-item">
            <button
              onClick={handleToggleMenuSidebar}
              type="button"
              className="nav-link"
            >
              <i className="fas fa-bars" />
            </button>
          </li>
        </ul>
      }
      {props.user && props.user.role_id != 1 &&
        <div className="header_logo_wrap">
          <a href="/">
            <img src="/img/logo.svg" className="adminheaderlogo" alt='Slomins' width={160} height={45} />
          </a>
        </div>
      }
      {props.user && props.user.role_id != 1 &&
        <div className="rep_info text-right w-100">
          <span className="rep_name">{props.user.name} <br /> {props.user.email}</span>
        </div>
      }
      <ul className="navbar-nav ml-auto">
        {/* <MessagesDropdown />
        <NotificationsDropdown />  */}
        <UserDropdown />
      </ul>
    </nav>
  );
};

export default Header;
